import { FC, PropsWithChildren } from 'react';
import middlewareConfig from '@/router/middlewareConfig.tsx';

type MiddlewareProps = {
  isLoading?: boolean;
};

const Middleware: FC<PropsWithChildren<MiddlewareProps>> = ({ isLoading = false, children }) => {
  return isLoading ? (middlewareConfig.loader ?? null) : children;
};

export default Middleware;
